import React, { useEffect, useState } from 'react';
import Product from './Product'
import {STATE} from '../classes/Enum';

function Products({cart, items, state, setCart}) {

  const addToCart = (item) => {
    const existingItemIndex = cart.findIndex(cartItem => cartItem.id === item.id);
    if (item.quantity <= 0) {
      return;
    }
  
    if (existingItemIndex >= 0 && cart[existingItemIndex].count >= item.quantity) {
      console.log("You added too many! I don't have enough :( Please get something else.");
    }
    else if (existingItemIndex >= 0) {
      // If item already exists in cart, update its quantity
      const updatedCart = [...cart];
      updatedCart[existingItemIndex].count += 1;
      setCart(updatedCart);
      // console.log('Incrementing quantity');
    } else {
      // If item doesn't exist in cart, add it
      const itemToAdd = {...item, count:1};
      setCart([...cart, itemToAdd]);
      // console.log('Added item to cart!');
    }
  };

  return (
    <div id="item-container">
      {(state === STATE.OVERVIEW ? items : items.filter(item => item.type === state))
        .map(item => {
          const cartItem = cart.find(cartItem => cartItem.id === item.id);
          const count = cartItem ? cartItem.count : 0; // Default count to 0 if item not found
          return <Product item={item} addToCart={addToCart} count={count} key={item.id} />;
        })}
    </div>
  );
  
}

export default Products;
